const form = {
  login: {
    user: "Username",
    password: "Password",
    submit: "Sign in",
  }
};

export default form;
